import React from 'react';

import SignupWindow from '../components/Auth/SignupWindow';

const SignupPage = () => {
  
  return (
    <div className="flex-1">
      <SignupWindow />
    </div>
  )
}

export default SignupPage;